export const preview = (src: string) => {
  const newTab = window.open("");
  newTab?.document.write(
    "<iframe width='100%' height='100%' style='border-width: 0;' src='" +
      encodeURI(src) +
      "'></iframe>"
  );
};
